var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLighthouse = function SvgLighthouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "helpbox_a",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00B1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#00C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "helpbox_b",
    x1: "0%",
    y1: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FB0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#helpbox_a)",
    d: "M43 23.977h2.5a1.5 1.5 0 0 1 1.5 1.5v9a1.5 1.5 0 0 1-1.5 1.5h-2.106l2.301 25.134h2.292a1.5 1.5 0 0 1 0 3H14.833a1.5 1.5 0 1 1 0-3h3.17l2.3-25.134H18.5a1.5 1.5 0 0 1-1.5-1.5v-9a1.5 1.5 0 0 1 1.5-1.5H21v-15h22v15zm-12.5 3H20v6h10.5v-6zm3 0v6H44v-6H33.5zm-11.298 21.18l-.297 3.243h.002l-.273 3h-.004l-.614 6.711h21.667l-.615-6.711h-.032l-.26-3h.018l-.337-3.676-1.025-11.81h-17.15l-1.08 12.242zM43 23.976h-3v-12H24v12h-3 22zM31.822 12.092l-12.336-.115c-1.423-.014-2.03-1.815-.905-2.686l6.062-4.696 5.031-3.87a3.5 3.5 0 0 1 4.268 0l4.999 3.847 6.442 4.692c1.168.851.576 2.7-.87 2.713l-12.691.115zm8.128-3.074l-2.807-2.045-5.03-3.87a.5.5 0 0 0-.61 0L26.476 6.97l-2.642 2.047 7.974.075 8.142-.074zm20.243 10.959h-8.654a1.5 1.5 0 0 1 0-3h8.654a1.5 1.5 0 0 1 0 3zm-2.795 8.58l-7.693-4.808a1.5 1.5 0 1 1 1.59-2.544l7.693 4.808a1.5 1.5 0 1 1-1.59 2.544zm1.59-17.808l-7.693 4.808a1.5 1.5 0 0 1-1.59-2.544l7.693-4.808a1.5 1.5 0 1 1 1.59 2.544zM4.5 19.977a1.5 1.5 0 0 1 0-3h8.654a1.5 1.5 0 0 1 0 3H4.5zm2.795 8.58a1.5 1.5 0 0 1-1.59-2.544l7.692-4.808a1.5 1.5 0 1 1 1.59 2.544l-7.692 4.808zm-1.59-17.808a1.5 1.5 0 0 1 1.59-2.544l7.692 4.808a1.5 1.5 0 1 1-1.59 2.544l-7.692-4.808z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#helpbox_b)",
    d: "M32 22.727a5 5 0 1 1 0-10 5 5 0 0 1 0 10zm0-3a2 2 0 1 0 0-4 2 2 0 0 0 0 4z"
  }))));
};
export default SvgLighthouse;